import React, { useState } from 'react';
import { connect } from "react-redux";
import moment from "moment";
import ICDateInput from "../../components/form/dateInput";
import ICCheckbox from "../../components/form/checkbox";
import ICSelect from "../../components/form/selectInput";
import { cpdMOTags, STATE_LIST } from "../../constants/helperConstants";
import { CircularProgress, Paper, Slider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import Label from "../../components/label";
import ICIconBtn from "../../components/iconButton";
import MakeAPICall from "../../apiCalls/common";

import DefaultImg from "../../assets/images/default-picture.png";
import MultiSelectCheckboxAutocomplete from '../../components/form/tagSearchInput';
import { tagsTopicsListAPI } from '../../apiRoutes';
import { useEffect } from 'react';
import { useRef } from 'react';
import APP_CONSTANTS from '../../constants';
import { useCallback } from 'react';

const AGE_MARKS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120].map((val) => { return { value: val, label: val } });

const TagTopicsCPDPage = (props) => {

    const observer = useRef(); // to check it is the last element or not - if it is last element then call an API

    const states = [{
        stateId: "None"
    }, ...STATE_LIST];

    const [isLoading, setIsLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(0);
    const [noMoreData, setNoMoreData] = useState(false);
    const [isTodayFilter, setIsTodayFilter] = useState(false);
    const [isThisWeekFilter, setIsThisWeekFilter] = useState(false);

    const [filterObj, setFilterObj] = useState({
        startDate: new Date(moment().subtract(7, "days").format("MM/DD/YYYY")).toISOString(),
        endDate: moment().endOf('d').toISOString(),
        todayDateCheckbox: false,
        thisWeekDateCheckbox: false,
        ageRange: [0, 130],
        gender: '',
        state: '',
        selectedTags: [],
        limit: 10
    });

    const [data, setData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
        

    const [filterActive, setFilterActive] = useState(false);

    const [apiCall, setAPICall] = useState(null);

    const applyTodayDateFilter = () => {
        resetData();
        setFilterActive(true);
        setIsLoading(true);
        setTimeout(() => {
            let newFilterObj = {
                ...filterObj,
                skip: 0,
                startDate: moment().startOf('d').toISOString(),
                endDate: moment().endOf('d').toISOString(),
            };
            setFilterObj(newFilterObj);
            getTopicsList(newFilterObj);
        }, 800);
    }

    const applyThisWeekDateFilter = () => {
        setCurrentPage(0);
        resetData();
        setFilterActive(true);
        setIsLoading(true);
        setTimeout(() => {
            let newFilterObj = {
                ...filterObj,
                skip: 0,
                startDate: moment().subtract(7, 'd').startOf('d').toISOString(),
                endDate: moment().endOf('d').toISOString(),
            };
            setFilterObj(newFilterObj);
            getTopicsList(newFilterObj);
        }, 800);
    }

    const clearFilter = () => {
        setCurrentPage(0);
        data.splice(0, data.length);
        setData([...data]); // to force re-render
        setTotalCount(0);

        setFilterObj((prev) => ({
            ...prev,
            startDate: new Date(moment().subtract(7, "days").format("MM/DD/YYYY")).toISOString(),
            endDate: new Date().toISOString(),
            todayDateCheckbox: false,
            thisWeekDateCheckbox: false,
            ageRange: [0, 130],
            gender: '',
            state: '',
            selectedTags: [],
            limit: 10
        }))
            
        setIsLoading(true);
        setTimeout(() => {
            let newFilterObj = {
                ...filterObj,
                skip: 0
            };
            setFilterObj(newFilterObj);
            getTopicsList(newFilterObj);
        }, 800);
    }

    const resetData = () => {
        setCurrentPage(() => (0));
        setNoMoreData(false);
        data.splice(0, data.length);
        setData([...data]); // to force re-render
        setTotalCount(0);
    }

    const filterData = () => {
        resetData();
        setFilterActive(true);
        setIsLoading(true);
        setTimeout(() => {
            let newFilterObj = {
                ...filterObj,
                skip: 0
            };
            setFilterObj(newFilterObj);
            getTopicsList(newFilterObj);
        }, 800);
    };

    const getTopicsList = (currentFilter) => {
        setIsLoading(true);
        const dataToSend = {
            startDate:currentFilter ? currentFilter.startDate :  filterObj.startDate,
            endDate: currentFilter ? currentFilter.endDate :  filterObj.endDate,
            skip:currentFilter ? currentFilter.skip : currentPage * filterObj.limit,
            limit: currentFilter ? currentFilter.limit : filterObj.limit,
            gender: currentFilter ? currentFilter.gender : filterObj.gender,
            state: currentFilter ? currentFilter.state : filterObj.state,
            ageStart: currentFilter ? currentFilter.ageRange[0] : filterObj.ageRange[0],
            ageEnd: currentFilter ? currentFilter.ageRange[1] : filterObj.ageRange[1],
            topics: currentFilter ? currentFilter.selectedTags : filterObj.selectedTags
        };
        let apiCallParam = {
            reqType: "POST",
            reqURL: tagsTopicsListAPI,
            dataObj: dataToSend,
            params: {},
            headers: {},
            successCallback: res => {
                setCurrentPage(currentPage + 1);
                let consultNoteData = [...data, ...res.data.data.consultNotes];
                if (!res.data.data.consultNotes.length) setNoMoreData(true);
                
                setTotalCount(res.data.data.totalCount);
                setData((prev) => [...consultNoteData]);
                setIsLoading(false);
            },
            failureCallback: err => {
                setIsLoading(false);

            },
            showPopUp: false
        };
        setAPICall(apiCallParam);
    };

    const openPatientRecord = (patientId) => {
        const auth = props.auth.userData;
            window.open(
              APP_CONSTANTS.pmsURL +
                "/patient/patientDetails?accessToken=" +
                auth.accessToken +
                "&patientId=" +
                patientId +
                "&searchType=DOCTOR" +
                "&adminName=" +
                auth.firstName +
                " " +
                auth.lastName,
              "_blank"
            );
    }

      /*
       * Check last element is visible or not on scroll
       */
      const lastElementRef = useCallback(node => {
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(nodeData => {
            if (nodeData) {
                if (nodeData[0].isIntersecting && data.length < totalCount && !isLoading && !noMoreData) {
                setIsLoading(true);
                    let newFilterObj = {
                        ...filterObj,
                        skip: currentPage * filterObj.limit
                    };
                    setFilterObj(newFilterObj);
                getTopicsList();
            }
          }
        });
        if (node) observer.current.observe(node);
      });

    // useEffect(() => {
    //     const observer = new IntersectionObserver(
    //         entries => {
    //             const entry = entries[0];
    //             console.log("---- ", data.length, totalCount, isLoading);
    //             if (
    //                 entry.isIntersecting &&
    //                 data.length < totalCount && isLoading
    //             ) {
    //                 setIsLoading(true);
    //                 console.log("Loading new");
    //                 getTopicsList();
    //             }
    //         },
    //         { threshold: 1.0 } // Fully visible
    //     );

    //     if (observerRef.current) {
    //         observer.observe(observerRef.current);
    //     }

    //     return () => {
    //         if (observerRef.current) {
    //             observer.unobserve(observerRef.current);
    //         }
    //     };
    // }, [data]);

    useEffect(() => {
        getTopicsList();
    }, []);

    return (
        <div className="row rounded p-3 tag-topics-page">
            {/* Top Filters */}
            <div className="col-sm-12 pt-3 pl-3">
                <Label title="Tagged Topics (CPD MO)" className="big" />
            </div>
            <div
                className="row col-md-12 pl-3 pt-2 pr-0 pb-3 d-flex flex-row flex-wrap justify-content-between align-baseline">
                <div className="row col-sm-12">
                    <div className="col-sm-3 pt-2">
                        <ICDateInput
                            id="startdate"
                            className="cal-primary-bg mt-2"
                            label="Start Date"
                            defaultDate={filterObj.startDate}
                            handleChange={(date) => {
                                setFilterActive(false);
                                setIsTodayFilter(false);
                                setIsThisWeekFilter(false);
                                const startDate = moment(date).startOf('d').toISOString();
                                setFilterObj(prev => ({
                                    ...prev,
                                    startDate: startDate,
                                }));
                            }
                            }
                            filterOn={filterObj.startDate}
                        />
                    </div>
                    <div className="col-sm-3 pt-2 pr-0">
                        <ICDateInput
                            id="endDate"
                            className="cal-primary-bg mt-2"
                            label="End Date"
                            defaultDate={filterObj.endDate}
                            handleChange={date => {
                                setFilterActive(false);
                                setIsTodayFilter(false);
                                setIsThisWeekFilter(false);
                                const endDate = moment(date).endOf('d').toISOString();
                                setFilterObj(prev => ({
                                    ...prev,
                                    endDate: endDate,
                                }));
                                
                            }}
                            filterOn={filterObj.endDate}
                        />
                    </div>
                    <div className="col-sm-3">
                        <MultiSelectCheckboxAutocomplete selectedTags={filterObj.selectedTags} tags={cpdMOTags} setValues={(values) => {
                            setCurrentPage(0);
                            setFilterActive(false);
                            setFilterObj(prev => ({
                                ...prev,
                                selectedTags: values
                            }));
                        }} />
                    </div>
                    <div className="row flex-grow-1"></div>
                    <div>
                        <div className="row">
                            <Label
                                className="col-md-7 m-0 p-0 d-flex align-items-center justify-content-end"
                                title="Today"
                            />
                            <div className="col-md-5 ic-checkbox-container">
                                <ICCheckbox
                                    name="todayDateCheckbox"
                                    onChange={() => {
                                        setCurrentPage(0);
                                        setIsTodayFilter(true);
                                        setIsThisWeekFilter(false);
                                        applyTodayDateFilter();
                                    }}
                                    value={isTodayFilter}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <Label
                                className="col-md-7 m-0 p-0 d-flex align-items-center justify-content-end"
                                title="This Week"
                            />
                            <div className="col-md-5 ic-checkbox-container">
                                <ICCheckbox
                                    name="thisWeelDateCheckbox"
                                    onChange={() => {
                                        setCurrentPage(0);
                                        setIsTodayFilter(false);
                                        setIsThisWeekFilter(true);
                                        applyThisWeekDateFilter();
                                    }}
                                    value={isThisWeekFilter}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row flex-grow-1 mt-1">
                    <div className="ml-4 row col-sm-5">
                        <Label className="gray small" title="Age Range" />
                        <Slider
                            className='primary-color'
                            marks={AGE_MARKS}
                            min={0}
                            max={130}
                            value={filterObj.ageRange}
                            onChange={(e, ageRange) => {
                                setCurrentPage(0);
                                setFilterActive(false);
                                setFilterObj(prev => ({
                                    ...prev,
                                    ageRange: ageRange
                                }));
                            }}
                            valueLabelDisplay="auto"
                            aria-labelledby="range-slider"
                        />
                    </div>

                    <div className="row col-sm-5">
                        <div className="col-sm-6">
                            <Label className="gray small" title="Gender" required={true} />
                            <ICSelect
                                label=""
                                placeholder="Select Gender"
                                useId="_id"
                                useValue="val"
                                items={[
                                    { _id: "None", val: 'None' },
                                    { _id: "Male", val: "Male" },
                                    { _id: "Female", val: "Female" }
                                ]}
                                value={filterObj.gender}
                                handleChange={val => {
                                    setCurrentPage(0);
                                    setFilterActive(false);
                                    setFilterObj(prev => ({
                                        ...prev,
                                        gender: val === "None" ? '' : val
                                    }));
                                }}
                            />
                        </div>

                        <div className="col-sm-6">
                            <Label className="gray small" title="State" required={true} />
                            <ICSelect
                                label=""
                                placeholder="Select State"
                                items={states}
                                useId="stateId"
                                useValue="stateId"
                                value={filterObj.state}
                                handleChange={val => {
                                    setFilterActive(false);
                                    setFilterObj({
                                        ...filterObj,
                                        state: val === "None" ? '': val
                                    });
                                }}
                            />
                        </div>
                    </div>
                    <ICIconBtn
                        title=""
                        className={
                            !filterActive ? "font-15 only-icon mt-4" : "d-none"
                        }
                        type="button"
                        clickEvent={filterData}
                        icon="fas fa-arrow-right"
                    />

                    <ICIconBtn
                        title=""
                        className={
                            filterActive
                                ? "font-15 only-icon danger mt-4"
                                : "d-none"
                        }
                        type="button"
                        clickEvent={clearFilter}
                        icon="fas fa-times"
                    />
                </div>
            </div>

            <div className="col-sm-12 border-bottom"></div>

            <div className="col-sm-12 mt-4">
                <Paper className="w-100 tag-topics-list">
                    <TableContainer className="table-max-height primary-table-color tag-topics-table">
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                {/* Loop on Column name  */}
                                <TableRow>
                                    <TableCell>
                                        <Label title="Patient UIN" />
                                    </TableCell>
                                    <TableCell>
                                        <Label title="Patient Details" />
                                    </TableCell>
                                    <TableCell>
                                        <Label title="Topics" />
                                    </TableCell>
                                    <TableCell>
                                        <Label title="Date" />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                        {
                            data.map((consultNote, index) => {
                                const isThirdLast = index === data.length - 3;
                                let phone = consultNote.patient.phoneNumber.substring(0, 4) + ' ' + consultNote.patient.phoneNumber.substring(4, 7) + ' ' + consultNote.patient.phoneNumber.substring(7, 10);
                                return (
                                    <TableRow key={index} ref={isThirdLast ? lastElementRef : null}>
                                        <TableCell>
                                            <span className='primary-font text-bold cursor-pointer' onClick={() => openPatientRecord(consultNote.patient._id)}>{consultNote.patient.patientId}</span>
                                        </TableCell>
                                        <TableCell>
                                            <div className='d-flex'>
                                                <img
                                                    src={consultNote.patient.profilePic.original || DefaultImg}
                                                    alt="user-ic-patient"
                                                    className="patient-image user-img-rounded rounded-circle border mb-1"
                                                />
                                                <div className='patient-details ml-3'>
                                                    <Label title={`${consultNote.patient.firstName} ${consultNote.patient.lastName}`} className="p-0 m-0" />
                                                    <Label title={`${consultNote.patient.email}`} className="small p-0 m-0" />
                                                    <Label title={`${phone}`} className="small p-0 m-0" />
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <Label title={consultNote.cpdMOTags.join(', ')} />
                                        </TableCell>
                                        <TableCell>
                                            <Label title={moment(consultNote.createdAt).format("DD-MM-YYYY")} />
                                            <br />
                                            <Label title={moment(consultNote.createdAt).format("h:mm a")} />
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        }

                        {
                            data.length === 0 && !isLoading && (
                                        <TableRow>
                                            <TableCell colSpan={4} className='text-center'>
                                                <Label title="No Data Found"/>
                                            </TableCell>
                                        </TableRow>
                            )
                        }
                                

                                <TableRow className={isLoading ? "" : "d-none"}>
                                    <TableCell
                                        colSpan={7}
                                        className="text-center progress-bar-center"
                                    >
                                        <CircularProgress disableShrink className="primary-loader" />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </div>

            {/* API Call */}
            <MakeAPICall apiParam={apiCall} />
        </div>
    )
}

const mapStateToProps = props => ({
  auth: props.auth.user,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TagTopicsCPDPage);
